// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  direction: 'rtl',

  palette: {
    mode: 'light',

    primary: {
    main: '#2563EB'
},

    secondary: {
      main: '#14B8A6',
    },

    success: {
      main: '#16A34A',
    },

    warning: {
      main: '#F59E0B',
    },

    error: {
      main: '#DC2626',
    },

    info: {
      main: '#0284C7',
    },

    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
  },

  shape: {
    borderRadius: 12,
  },

  typography: {
    fontFamily: '"Alexandria", "Segoe UI", Tahoma, sans-serif',

    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },

    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },

    subtitle1: {
      fontWeight: 600,
      fontSize: 15,
    },

    subtitle2: {
      fontWeight: 500,
      fontSize: 14,
    },

    body1: {
      fontWeight: 500,
      fontSize: 14,
    },

    body2: {
      fontWeight: 400,
      fontSize: 13,
    },

    button: {
      fontWeight: 600,
      fontSize: 14,
      textTransform: 'none',
    },
  },

  components: {

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          height: 40,
          boxShadow: 'none',
          fontWeight: 600,

          '&:hover': {
            boxShadow: '0 4px 12px rgba(37,99,235,.20)',
          },
        },
      },
    },

    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          background: '#fff',
          minHeight: 40,
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          boxShadow: '0 2px 10px rgba(15,23,42,.08)',
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },

    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#F1F5F9',
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          color: '#334155',
        },

        body: {
          fontWeight: 500,
        },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 10px rgba(0,0,0,.08)',
        },
      },
    },

  },
});

export default theme;